import { render } from "./manage-stocks-modal.vue?vue&type=template&id=7c5dd9a5&scoped=true"
import script from "./manage-stocks-modal.vue?vue&type=script&lang=js"
export * from "./manage-stocks-modal.vue?vue&type=script&lang=js"

import "./manage-stocks-modal.vue?vue&type=style&index=0&id=7c5dd9a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5dd9a5"]])

export default __exports__